export default __webpack_public_path__ + "static/media/confirm-email.bd42d0d1.svg";